module.exports = __webpack_public_path__ + "img/1_004.42ac5432.webp";